
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/client/lib",
      function () {
        return require("private-next-pages/docs/client/lib.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/client/lib"])
      });
    }
  